import styles from './About.module.css';
import heart from '../../shared/assets/icons/heart.png';
import safe from '../../shared/assets/icons/safe.png';
import idea from '../../shared/assets/icons/idea.png';
import secret from '../../shared/assets/icons/secret.png';
import ContourBackdrop from '../../components/ContourBackdrop/ContourBackdrop';
import { useIntl } from 'react-intl';

// The mockup's two photographs, resized and bundled so they are hashed and
// cached like the rest of the assets.
import heroPhoto from '../../shared/assets/illustrations/about-hero.jpg';
import missionPhoto from '../../shared/assets/illustrations/about-mission.jpg';

const About = () => {
	const intl = useIntl();

	const values = [
		{
			icon: safe,
			title: intl.formatMessage({ id: 'AboutUsId29' }),
			text: intl.formatMessage({ id: 'AboutUsId30' }),
		},
		{
			icon: heart,
			title: intl.formatMessage({ id: 'AboutUsId31' }),
			text: intl.formatMessage({ id: 'AboutUsId32' }),
		},
		{
			icon: idea,
			title: intl.formatMessage({ id: 'AboutUsId33' }),
			text: intl.formatMessage({ id: 'AboutUsId34' }),
		},
		{
			icon: secret,
			title: intl.formatMessage({ id: 'AboutUsId35' }),
			text: intl.formatMessage({ id: 'AboutUsId36' }),
		},
	];

	// The five "what we're creating" lines are one sentence each, split across
	// three message ids so the middle phrase can be bold.
	const creating = [
		['AboutUsId9', 'AboutUsId10', 'AboutUsId11'],
		['AboutUsId12', 'AboutUsId13', 'AboutUsId14'],
		['AboutUsId15', 'AboutUsId16', 'AboutUsId17'],
		['AboutUsId18', 'AboutUsId19', 'AboutUsId20'],
		['AboutUsId21', 'AboutUsId22', 'AboutUsId23'],
	];

	return (
		<div className={styles.page}>
			<main className={styles.main}>
				{/* Hero + the two story cards that sit over the photo */}
				<section className={styles.hero}>
					<div
						className={styles.heroPhoto}
						style={{ backgroundImage: `url("${heroPhoto}")` }}
						aria-hidden='true'
					/>
					<ContourBackdrop
						className={styles.heroContours}
						rings={7}
						from={3.4}
					/>

					<div className={styles.container}>
						<div className={styles.heroHeader}>
							<h1 className={styles.heroTitle}>
								{intl.formatMessage({ id: 'AboutUsId1' })}
							</h1>
							<p className={styles.heroLead}>
								{intl.formatMessage({ id: 'AboutUsId2' })}
							</p>
						</div>

						<div className={styles.storyGrid}>
							<article className={styles.storyCard}>
								<h2 className={styles.cardTitle}>
									{intl.formatMessage({ id: 'AboutUsId3' })}
								</h2>
								<p className={styles.cardText}>
									{intl.formatMessage({ id: 'AboutUsId4' })}
								</p>
								<p className={styles.cardText}>
									{intl.formatMessage({ id: 'AboutUsId5' })}
								</p>
								<p className={styles.cardText}>
									{intl.formatMessage({ id: 'AboutUsId6' })}
								</p>
							</article>

							<article className={`${styles.storyCard} ${styles.creatingCard}`}>
								<h2 className={styles.cardTitle}>
									{intl.formatMessage({ id: 'AboutUsId7' })}
								</h2>
								<p className={styles.cardLead}>
									{intl.formatMessage({ id: 'AboutUsId8' })}
								</p>
								<ul className={styles.featureList}>
									{creating.map(([lead, strong, tail]) => (
										<li key={strong} className={styles.featureItem}>
											{intl.formatMessage({ id: lead })}{' '}
											<strong>{intl.formatMessage({ id: strong })}</strong>{' '}
											{intl.formatMessage({ id: tail })}
										</li>
									))}
								</ul>
							</article>
						</div>
					</div>
				</section>

				{/* Mission */}
				<section className={styles.missionSection}>
					<ContourBackdrop
						className={styles.missionContours}
						rings={7}
						from={3.4}
					/>

					<div className={styles.container}>
						<div className={styles.missionGrid}>
							<div className={styles.missionCopy}>
								<h2 className={styles.sectionTitle}>
									{intl.formatMessage({ id: 'AboutUsId25' })}
								</h2>
								<p className={styles.sectionSubtitle}>
									{intl.formatMessage({ id: 'AboutUsId24' })}
								</p>
								<p className={styles.missionText}>
									{intl.formatMessage({ id: 'AboutUsId26' })}
								</p>
							</div>

							<div className={styles.missionImage}>
								<img src={missionPhoto} alt='' loading='lazy' />
							</div>
						</div>
					</div>
				</section>

				{/* Values */}
				<section className={styles.valuesSection}>
					<ContourBackdrop
						className={styles.valuesContours}
						rings={7}
						from={3.4}
					/>

					<div className={styles.container}>
						<div className={styles.valuesHeader}>
							<h2 className={styles.sectionTitle}>
								{intl.formatMessage({ id: 'AboutUsId28' })}
							</h2>
							<p className={styles.sectionSubtitle}>
								{intl.formatMessage({ id: 'AboutUsId27' })}
							</p>
						</div>

						<div className={styles.valuesGrid}>
							{values.map(value => (
								<article key={value.title} className={styles.valueCard}>
									<div className={styles.valueIcon}>
										<img src={value.icon} alt='' />
									</div>
									<h3 className={styles.valueTitle}>{value.title}</h3>
									<p className={styles.valueText}>{value.text}</p>
								</article>
							))}
						</div>
					</div>
				</section>
			</main>
		</div>
	);
};

export default About;
